import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { useConfigUI } from '@/features/config/context'
import { DeleteType } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function deleteHyraulic(interfaceId: string, id: string): Promise<void> {
  await flowValveApi.delete(interfaceId, id)
}
const useDeleteFlowValve = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: DeleteType) => deleteHyraulic(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.flowValve])
        toast.success(t('deleteFlowValveSuccess'))
        closeModal()
      },
      onError: (error: AxiosError<any>) => {
        toast.error(getApiErrorMessage(error))
        closeModal()
      },
    },
  )
}

export default useDeleteFlowValve
